import PropTypes from "prop-types";
import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,

} from "reactstrap";

// Pages Components
import WelcomeComp from "./WelcomeComp";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";
import Line from "../AllCharts/echart/linechart"
import LineChart from "../AllCharts/chartjs/linechart"

import {
  getUsers as onGetUsers,
    getSliders as onGetSliders, 
  getNews_Category as onGetNews_Category,
      getJob_Advertisement_SubCategory as onGetJob_Advertisement_SubCategory,
        getCompany_Advert_Price as onGetCompany_Advert_Price,

} from "store/contacts/actions";
const Dashboard = props => {
  const dispatch = useDispatch();

  const { users } = useSelector(state => ({
    users: state.contacts.users,
  }));

  const { companyadvertprice } = useSelector(state => ({
    companyadvertprice: state.contacts.companyadvertprice,
  }));
  
  const { ne } = useSelector(state => ({
    ne: state.contacts.ne,
  }));

    const { sliders } = useSelector(state => ({
    sliders: state.contacts.sliders,
  }));

      const { jobadvertisementsubcategory } = useSelector(state => ({
    jobadvertisementsubcategory: state.contacts.jobadvertisementsubcategory,
  }));



  const reports = [
    { title: "Toplam Üye", iconClass: "bx-archive-in", description: users.length },
       { title: "Toplam Danışman", iconClass: "bx-archive-in", description: jobadvertisementsubcategory.length },
              { title: "Toplam Yorum", iconClass: "bx-archive-in", description: companyadvertprice.length },
              { title: "Toplam Randevu", iconClass: "bx-archive-in", description: sliders.length },

  ];

    useEffect(() => {
    if (sliders && !sliders.length) {
      dispatch(onGetSliders());
    }
  }, [dispatch, sliders]);


    useEffect(() => {
    if (companyadvertprice && !companyadvertprice.length) {
      dispatch(onGetCompany_Advert_Price());
    }
  }, [dispatch, companyadvertprice]);

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetUsers());
    }
  }, [dispatch, users]);


    useEffect(() => {
    if (jobadvertisementsubcategory && !jobadvertisementsubcategory.length) {
      dispatch(onGetJob_Advertisement_SubCategory());
    }
  }, [dispatch, jobadvertisementsubcategory]);

    useEffect(() => {
    if (ne && !ne.length) {
      dispatch(onGetNews_Category());
    }
  }, [dispatch, ne]);

  //meta title
  document.title = "Anasayfa | Danışmana Sor Admin Paneli";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Yönetim")}
            breadcrumbItem={props.t("Anasayfa")}
          />

          <Row>
            <Col xl="4">
              <WelcomeComp />
            </Col>
            <Col xl="8">
             <Row>
                {/* Reports Render */}
                {reports.map((report, key) => (
                  <Col md="4" key={"_col_" + key}>
                    <Card className="mini-stats-wid">
                    <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                            {report.title}
                            </p>
                            <h4 className="mb-0">{report.description}</h4>
                          </div>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                            <span className="avatar-title rounded-circle bg-primary">
                              <i
                                className={
                                  "bx " + report.iconClass + " font-size-24"
                                }
                              ></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>


                  <div id="line-chart" className="e-chart">
      <Line dataColors='["--bs-success"]' polls={jobadvertisementsubcategory} />
                  </div>


                  <LineChart  users={users} dataColors='["--bs-primary-rgb, 0.2", "--bs-primary", "--bs-light-rgb, 0.2", "--bs-light"]' />


             
            </Col>
          </Row>

        

         
        </Container>
      </div>


    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
